import {IconBox, IconProps} from "../index";
import React from "react";

import TwitterSvg from "../../../../assets/icons/social/twitter.svg?react";

export const TwitterIcon = (props: IconProps) => {
    return (
        <IconBox {...props}>
            <TwitterSvg/>
        </IconBox>
    );
}
